import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Inventory2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"inventory_2"}/>
}
